import { Directive, OnInit, HostListener, OnDestroy, Output, EventEmitter, ElementRef } from '@angular/core';

@Directive({
    selector: '[ctrlF]'
})

export class CtrlFDetectorDirective {

    @Output() ctrlF: EventEmitter<boolean>=new EventEmitter();
    constructor() {
    }

    @HostListener('window:keydown', ['$event'])
    onKeyDown(event: KeyboardEvent): void {

        //if (event.getModifierState && event.shiftKey && event.keyCode===70) {
        if (event.getModifierState && event.getModifierState('Control') && event.keyCode===70) {
            this.ctrlF.emit(true);
        }
    }
}
